import React, { useState } from 'react';
import './signUpForm.css';
// import { useGoogleOAuth } from '../../hooks/authentication/useGoogleOAuth';

const SignUpForm = ({
  formState,
  handleChange,
  handleSubmit,
  error,
  userType,
  onShowTerms,
  onGoogleSignInSuccess,
}) =>{
  const [showTerms, setShowTerms] = useState(false);

  const profileType  = userType === 'profesionales' ? 'trabajadores' : 'empresas'

  // Use the Google OAuth hook
  // const { googleButtonRef } = useGoogleOAuth(userType, onGoogleSignInSuccess, 'signup_with');

  return (
    <form className="sign-up-form__container" onSubmit={handleSubmit}>
      <h2>Crea tu cuenta {profileType}</h2>
      <div className="sign-up-form__input-container">
        <label className="sign-up-form__label">Email</label>
        <input
          type="email"
          name="email"
          placeholder="Email"
          value={formState.email}
          onChange={handleChange}
          className="sign-up-form__input"
        />
      </div>
      <div className="sign-up-form__input-container">
        <label className="sign-up-form__label">Contraseña</label>
        <input
          type="password"
          name="password"
          placeholder="Contraseña"
          value={formState.password}
          onChange={handleChange}
          className="sign-up-form__input"
        />
      </div>
      <div className="sign-up-form__input-container">
        <label className="sign-up-form__label">Confirmar Contraseña</label>
        <input
          type="password"
          name="confirmPassword"
          placeholder="Confirma tu contraseña"
          value={formState.confirmPassword}
          onChange={handleChange}
          className="sign-up-form__input"
        />
      </div>
      <div className="sign-up-form__input-container">
        <label className="sign-up-form__label">Nombre</label>
        <input
          type="text"
          name="name"
          placeholder="Nombre"
          value={formState.name}
          onChange={handleChange}
          className="sign-up-form__input"
        />
      </div>
      <div className="sign-up-form__input-container">
        <label className="sign-up-form__label">Teléfono</label>
        <input
          type="text"
          name="phoneNumber"
          placeholder="Teléfono"
          className="sign-up-form__input"
          value={formState.phoneNumber}
          onChange={handleChange}
        />
      </div>
      <div className="sign-up-form__input-container">
        <label className="sign-up-form__label">¿Cómo te enteraste de nosotros?</label>
        <select
          name="referralSource"
          className="sign-up-form__input"
          value={formState.referralSource}
          onChange={handleChange}
        >
          <option value="">Selecciona una opción</option>
          <option value="Instagram">Instagram</option>
          <option value="Google">Google</option>
          <option value="ChatGPT">ChatGPT</option>
          <option value="Facebook">Facebook</option>
          <option value="LinkedIn">LinkedIn</option>
          <option value="TikTok">TikTok</option>
          <option value="YouTube">YouTube</option>
          <option value="Amigo/Referido">Amigo/Referido</option>
          <option value="Otro">Otro</option>
        </select>
      </div>

      <div className="sign-up-form__input-checkbox-container">
        <input
          type="checkbox"
          name="termsAccepted"
          className="sign-up-form__input-checkbox"
          checked={formState.termsAccepted}
          onChange={handleChange}
        />
        <label className="sign-up-form__label">
          Acepto los{" "}
          <span
            className="sign-up-form__terms-link"
            style={{ color: "#fb5424", textDecoration: "underline", cursor: "pointer" }}
            onClick={onShowTerms}
          >
            Términos y Condiciones
          </span>
        </label>
      </div>
      <input type="submit" className="sign-up-form__button" value="Crear" />
      {error && <p className="sign-up-form__error-message">{error}</p>}
      
      {/* Google Sign-In Button at the bottom */}
      {/* <div className="google-signin-container">
        <div ref={googleButtonRef}></div>
      </div> */}
    </form>
  );};

export default SignUpForm;
